/**
 * KAN-752: обязательный выбор кампании (оператора канала telegram_user).
 *
 * Показывается, только когда включённых операторов канала больше одного:
 * при создании TG-списка и подключении TG-аккаунта. Один оператор - выбор
 * не нужен, бэкенд подставит его сам.
 */
import { Label } from '@/components/ui/label';
import { NativeSelect } from '@/components/ui/native-select';
import { operatorLabel } from '@/lib/channelOperators';
import type { ChannelOperator } from '@/services/api/channelOperators';

export const CAMPAIGN_SELECT_PLACEHOLDER = 'Выберите кампанию';

interface CampaignSelectProps {
  operators: ReadonlyArray<ChannelOperator>;
  value: string;
  onChange: (operatorId: string) => void;
  disabled?: boolean;
  hint?: string;
}

export function CampaignSelect({
  operators,
  value,
  onChange,
  disabled = false,
  hint,
}: CampaignSelectProps): JSX.Element {
  const options = operators.map((op) => ({
    value: op.id,
    label: operatorLabel(op.name, op.email),
  }));
  return (
    <div className="space-y-2" data-testid="campaign-select-field">
      <Label htmlFor="campaign-select">Кампания *</Label>
      <NativeSelect
        id="campaign-select"
        data-testid="campaign-select"
        required
        aria-required="true"
        aria-invalid={!value}
        disabled={disabled}
        value={value}
        placeholder={CAMPAIGN_SELECT_PLACEHOLDER}
        options={options}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint && <p className="text-xs text-gray-500">{hint}</p>}
    </div>
  );
}

export default CampaignSelect;
